import { colors } from '@/theme/colors';
import { SvgIconCommonProps } from './types/svg-icon-common-props';
import { cn } from '@/shadcn-ui/utils';

export default function Calendar({
  fillPrimary = colors.neutral10,
  className,
}: SvgIconCommonProps) {
  return (
    <svg
      viewBox="-1 -1 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn('h-[18px] w-[18px]', className)}
    >
      <g fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
        <g stroke={fillPrimary} strokeWidth="1.5">
          <g>
            <rect width="15" height="13" x=".501" y="2.5" rx="1.5" />
            <path d="M.501 6.5L15.501 6.5M4.501 4L4.501.5M11.501 4L11.501.5" />
          </g>
        </g>
      </g>
    </svg>
  );
}
